$(document).on("click",".variant-picker__option-values label",function() {
  setTimeout(function() {
    fetch(`${window.location.href}`).then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.orange-section');
      document.querySelector('.orange-section').innerHTML = html.innerHTML;
    })
    .catch(e => {
      console.error(e);
    })
    .finally(() => {
    });
  }, 50);
});